import { TaxCategoriesEnum } from '@gtpl/shared-models/common-models';
import {
  BaseEntity,
  Column,
  Entity,
  Index,
  JoinColumn,
  JoinTable,
  ManyToMany,
  ManyToOne,
  OneToMany,
  OneToOne,
  PrimaryColumn,
  PrimaryGeneratedColumn,
  RelationId,
  VersionColumn,
  UpdateDateColumn,
  CreateDateColumn,
} from 'typeorm';
import { VendorsPriceList } from '../vendors-price-list/entities/vendor-price-list.entity';
import { Item } from '../items/item.entity';

@Entity('taxes')
export class Taxes {
  @PrimaryGeneratedColumn('increment', { name: 'tax_id' })
  taxId: number;

  @Column('varchar', {
    nullable: false,
    length: 20,
    name: 'tax_name',
  })
  @Index({ unique: true })
  taxName: string;

  @Column('decimal', {
    nullable: false,
    name: 'tax_percentage',
    precision: 5,
    scale: 2,
  })
  taxPercentage: number;
  @Column({
    type: 'enum',
    nullable: false,
    enum: TaxCategoriesEnum,
    // default: TaxCategoriesEnum.OPEN,
    name: "tax_category"
  })
  taxcategory: TaxCategoriesEnum;

  @Column('boolean', {
    nullable: false,
    default: true,
    name: 'is_active',
  })
  isActive: boolean;

  @CreateDateColumn({
    name: 'created_at',
    type: 'datetime',
  })
  createdAt: Date;

  @Column('varchar', {
    nullable: false,
    name: 'created_user',
    length: 50,
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: 'updated_at',
    type: 'datetime',
  })
  updatedAt: Date;

  @Column('varchar', {
    nullable: true,
    name: 'updated_user',
    length: 50,
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: 'version_flag',
  })
  versionFlag: number;

  @OneToMany((type) => VendorsPriceList, (venPrcList) => venPrcList.taxes)
  vendorsPriceList: VendorsPriceList[];
  @OneToMany((type) => Item, (e) => e.taxInfo)
  itemInfo: Item[];
}
